module.exports = __webpack_public_path__ + "media/components/icons/symbol-defs-b6aa817a5e785de8facb7a5d385cc8a0.svg";